import { render } from "./AddressAutocomplete.vue?vue&type=template&id=23be2bae&scoped=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"

import "./AddressAutocomplete.vue?vue&type=style&index=0&id=23be2bae&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23be2bae"]])

export default __exports__